module.exports = __webpack_public_path__ + "static/media/brushsize.b21713ff.svg";